// Library
import React from 'react'

// Ui
import Row from 'ui/Row'
import Col from 'ui/Col'
import Input from 'ui/Form/Input'

const LessorChangePasswordView = () => {
  return (
    <Row>
      <Col sm={8} md={5}>
        <Input
          type="password"
          label="Password"
          value="******"
          disabled={true}
        />
      </Col>
    </Row>
  )
}

export default LessorChangePasswordView
